export default __webpack_public_path__ + "static/media/feature_image_2.1c7e7f84.webp";